<template>
  <b-container
    v-if="textColumns.length > 0"
    class="text-column-container"
    :class="{ 'no-background': noBackground }"
    :style="backgroundStyle"
  >
    <b-row class="text-column-row" :class="{ 'button-right': buttonPosition === 'right' }">
      <b-container>
        <b-row class="text-columns">
          <b-col
            v-for="(textColumn, index) in textColumns"
            :key="'textColumn-' + index"
            class="column-centered"
          >
            <div class="columns-container">
              <prismic-rich-text
                :style="{ color: textColor }"
                :field="textColumn.text"
                class="prismic-text-column text-center w-100"
              ></prismic-rich-text>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="button-container">
        <Button
          v-if="buttonText && buttonLink"
          shape="outline"
          color="transparent"
          :no-wrap="true"
          :font-color="textColor"
          :to="buttonLink"
          :blank="!isInternalLink"
        >
          {{ buttonText }}
        </Button>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import Button from 'UI/Button';

export default {
  components: {
    Button
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['slice'],
  data() {
    return {
      textColumns: [],
      buttonText: '',
      textColor: '',
      buttonPosition: '',
      buttonLink: '',
      isInternalLink: true,
      backgroundColor: '',
      backgroundImage: ''
    };
  },
  computed: {
    backgroundStyle() {
      const style = {};
      style.backgroundColor =
        this.backgroundColor && !this.backgroundImage ? this.backgroundColor : '';
      style.backgroundImage = this.backgroundImage ? `url(${this.backgroundImage}` : '';

      return style;
    },
    noBackground() {
      return !this.backgroundImage && !this.backgroundColor;
    }
  },
  created() {
    const columns = this.slice.items;
    const { primary } = this.slice;
    this.buttonText = primary.button_text;
    this.textColor = primary.text_color;
    this.buttonPosition = primary.button_position;
    this.buttonLink = primary.button_link;
    this.isInternalLink = primary.is_internal_link;
    this.backgroundColor = primary.background_color;
    this.backgroundImage = primary.background_image?.url;
    columns.forEach((el) => {
      if (el.text_column[0]?.text) {
        const textColumn = {
          text: el.text_column
        };
        this.textColumns.push(textColumn);
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.text-column-container {
  max-width: 100%;
  border-radius: 4px;
  padding: 10px 0;
  background-position: center;
  margin: 0 auto 10px;
  .text-column-row {
    flex-direction: column;
    padding: 5px 0 15px 0;
    .button-container {
      justify-content: center;
      display: flex;
    }
    &.button-right {
      flex-direction: row;
      flex-wrap: nowrap;
      padding: 0 30px 0 20px;
      align-items: center;
      justify-content: center;
      .container {
        margin-right: 10px;
        margin-left: 0;
      }
      .text-columns .column-centered {
        max-width: fit-content;
        padding: 0;
      }
    }
    .text-columns {
      @include md {
        display: block;
      }
    }
    @include md {
      display: block;
    }
  }

  .columns-container {
    display: flex;
    padding: 0 10px;
    @include lg {
      flex-basis: auto;
    }
  }

  .prismic-text-column {
    text-align: left;
    font-size: 16px;
    font-family: 'Poppins', sans-serif;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
    margin: 10px 0px;
  }
  &.no-background {
    padding: 0;
    .prismic-text-column {
      margin: 0;
    }
  }
}
</style>
<style lang="scss">
.text-column-container {
  .prismic-text-column {
    a {
      color: var(--exp-color);
      text-decoration: none;
    }
    p {
      margin: 0;
    }
  }
}
</style>
